const commonHeaders = [
  {
    key: 'name',
    label: 'Name',
    sortable: false,
    width: '150px',
  },
];
const headerConfigurations = {
  default: [
    ...commonHeaders,
    {
      key: 'description',
      label: 'Description',
      width: '300px',
    },
  ],
  labels: [...commonHeaders],
  status: [
    ...commonHeaders,
    {
      key: 'description',
      label: 'Description',
      width: '300px',
    },
    {
      key: 'color',
      label: 'Color',
      width: '100px',
    },
  ],
  fields: [
    ...commonHeaders,
  ],
};

export const getTableHeader = (entityType) => {
  if (!entityType) return headerConfigurations.default;

  if (entityType.includes('status') || entityType.includes('priority')) {
    return headerConfigurations.status;
  }

  if (entityType.includes('fields')) {
    return headerConfigurations.fields;
  }

  if (entityType.includes('labels')) {
    return headerConfigurations.labels;
  }

  return headerConfigurations.default;
};
export const configItems = {
  general: [
    { id: 'environments', label: 'Environments', type: 'ENVIRONMENT' },
    { id: 'labels', label: 'Labels', type: 'LABEL' },
    { id: 'priority', label: 'Priority', type: 'TEST_CASE_PRIORITY' },
    { id: 'modules', label: 'Modules', type: 'FUNCTIONAL_MODULE_FIELD' },
    { id: 'scope', label: 'Platforms & Coverage', type: 'SCOPE' },
    { id: 'testcyclepurpose', label: 'Test Cycle Purpose', type: 'PURPOSE' },
    { id: 'automationfields', label: 'Automation Config', type: 'AUTOMATION_FIELDS' },
  ],
  status: [
    { id: 'testcasestatus', label: 'Test Cases', type: 'TEST_CASE_STATUS' },
    { id: 'testcyclestatus', label: 'Test Cycles', type: 'TEST_CYCLE_STATUS' },
    {
      id: 'testexecutionstatus',
      label: 'Test Executions',
      type: 'TEST_EXECUTION_STATUS',
    },
  ],
   "Integrations & Automation": [
    { id: 'jira', label: 'JIRA', type: 'JIRA' },
    { id: 'api-token', label: 'API Token', type: 'API_TOKEN' },
    { id: 'integration', label: 'Jenkins/GitHub Actions', type: 'INTEGRATION' },
  ],
};
export const getConfigDetails = (id) => {
  let heading = '';
  let group = '';

  for (const category in configItems) {
    const item = configItems[category].find((item) => item.id === id);
    if (item) {
      heading = item.label;
      group = item.type;
      break;
    }
  }

  return { heading, group };
};

export const fieldsDropdownOptions = [
  { value: 'text', label: 'Text' },
  { value: 'number', label: 'Number' },
  { value: 'decimal_number', label: 'Decimal Number' },
  { value: 'text_field_single', label: 'Text Field (Single)' },
  { value: 'text_field_multiple', label: 'Text Field (Multiple)' },
  { value: 'select_list_single', label: 'Select List (Single)' },
  { value: 'select_list_multiple', label: 'Select List (Multiple)' },
  { value: 'user_picker', label: 'User Picker' },
  { value: 'date_picker', label: 'Date Picker' },
];
